import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Target, Flag } from "lucide-react";
import api from "@/lib/api";

export function GoalsAlignedNote({ projectId }) {
  const [goals, setGoals] = useState(null);
  useEffect(() => {
    if (!projectId) return;
    setGoals(null);
    api.get(`/projects/${projectId}/goals`).then((r) => setGoals(r.data)).catch(() => setGoals(false));
  }, [projectId]);
  if (goals === null) return null;
  if (!goals || goals.approved === false) {
    return (
      <div className="glass rounded-2xl p-3 border border-amber-500/30 bg-amber-500/5 text-sm flex items-center gap-2 flex-wrap" data-testid="goals-aligned-note-missing">
        <Target className="w-4 h-4 text-amber-500 shrink-0" />
        <span>لم تُعتمد أهداف (OKR/KPI) بعد — اعتمدها لتُجهَّز حملاتك ومحتواك وفقها.</span>
        <Link to="/app/goals" className="text-primary font-bold underline-offset-2 hover:underline" data-testid="goals-aligned-note-link">اعتماد الأهداف</Link>
      </div>
    );
  }
  const kr = (goals.key_results || [])[0];
  return (
    <div className="glass rounded-2xl p-3 border border-emerald-500/30 bg-emerald-500/5 text-sm flex items-start gap-2" data-testid="goals-aligned-note">
      <Flag className="w-4 h-4 text-emerald-500 shrink-0 mt-0.5" />
      <p className="leading-relaxed">
        نجهّز حملاتك ومحتواك وفق <b>استراتيجيتك وأهدافك المعتمدة</b> لتحقق نتائجك بأفضل الممارسات (OKR/KPI)
        {goals.objective ? <> — الهدف: <b>{goals.objective}</b></> : null}
        {kr?.label ? <> · النتيجة الأولى: {kr.label} ({kr.target} {kr.unit})</> : null}.
      </p>
    </div>
  );
}
